import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "boundary-plus-thumbnail__media" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  key: 1,
  class: "boundary-plus-thumbnail__placeholder"
}
const _hoisted_4 = {
  key: 2,
  class: "boundary-plus-thumbnail__play-button",
  "aria-hidden": "true"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon--play" }, null, -1 /* HOISTED */)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 3,
  class: "boundary-plus-thumbnail__duration"
}
const _hoisted_8 = ["aria-label"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: "image-grid-card image-grid-card--click boundary-plus-thumbnail",
    role: "button",
    tabindex: "0",
    onClick: _cache[2] || (_cache[2] = $event => (_ctx.$emit( 'open', $props.item ))),
    onKeyup: _cache[3] || (_cache[3] = _withKeys($event => (_ctx.$emit( 'open', $props.item )), ["enter"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      ($setup.thumbnail_url)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: $setup.thumbnail_url,
            alt: $props.item.type === 'boundary_plus_image' ? 'Boundary+ image' : 'Boundary+ video thumbnail',
            class: "boundary-plus-thumbnail__image",
            loading: "lazy",
            onLoad: _cache[0] || (_cache[0] = $event => (_ctx.$emit( 'image-loaded' )))
          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_2))
        : (_openBlock(), _createElementBlock("div", _hoisted_3)),
      ($props.item.type === 'boundary_plus_video')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
        : _createCommentVNode("v-if", true),
      ($props.item.type === 'boundary_plus_video' && $setup.formatted_duration)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString($setup.formatted_duration), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ]),
    ($props.isStaff)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: _normalizeClass(["image-grid-card__checkbox", { 'image-grid-card__checkbox--checked': $props.checked }]),
          "aria-label": $props.checked ? 'Deselect item' : 'Select item for deletion',
          onClick: _cache[1] || (_cache[1] = _withModifiers($event => (_ctx.$emit( 'check', $props.item )), ["stop"]))
        }, null, 10 /* CLASS, PROPS */, _hoisted_8))
      : _createCommentVNode("v-if", true)
  ], 32 /* HYDRATE_EVENTS */))
}